import { useLayoutEffect } from "react";
import { useMap } from "react-leaflet";

export function MapResizer() {
  const map = useMap();
  useLayoutEffect(() => {
    map.invalidateSize();
  }, [map]);
  return null;
}